import type { DemoCallPhase } from "~/features/demoCall/types";
import type { LivePhase } from "~/features/live/types";
import type { CallPhase } from "~/stores/useCallStore";

/** 通話中（発信中・着信中・通話接続中）かどうかを判定する */
export const isCallPhaseActive = (phase: CallPhase): boolean =>
  phase.type === "outgoingConnecting" ||
  phase.type === "incomingRinging" ||
  phase.type === "inCall";

/** 配信視聴中かどうかを判定する */
export const isLivePhaseActive = (phase: LivePhase): boolean =>
  phase === "connecting" || phase === "connected";

/**
 * 通話・配信の画面にいるか（/call/video・/call/audio・/call/live とその配下）。
 */
export const isCallOrLiveScreen = (pathname: string): boolean =>
  pathname === "/call" || pathname.startsWith("/call/");

/**
 * 通話・デモ通話・配信が「何もしていない」状態でないか、通話・配信の画面にいるか。
 *
 * isCallPhaseActive / isLivePhaseActive より広い。接続中・視聴中だけでなく、呼び出し中・着信中・
 * 終了後の画面・配信を抜ける途中も true。滞在時間で出す施策（「他の動画を見る」先回りシート）が、
 * 通話・配信の最中やその直後に重ねたり、画面を動かして通話を切ったりしないための判定。
 * React からは useIsCallOrLiveBusy、React 外からは isCallOrLiveBusyNow（lib/callActivity）で使う。
 */
export const isCallOrLiveBusyState = (args: {
  callPhase: CallPhase;
  demoCallPhase: DemoCallPhase;
  livePhase: LivePhase;
  pathname: string;
}): boolean =>
  args.callPhase.type !== "idle" ||
  args.demoCallPhase !== "idle" ||
  args.livePhase !== "idle" ||
  isCallOrLiveScreen(args.pathname);
